import React from 'react';
export const AppQrCode = () => {
  return (
    <div className="section-get-the-app__qr__GrV2S">
      <div className="qr-code__TyNAI qr-code--large__lSR3F">
        <svg
          width="136"
          height="136"
          viewBox="83.3 83.3 833.4 833.4"
          fill="#202020"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="83.3" y="370.7" width="28.7" height="28.7" />
          <rect x="83.3" y="428.2" width="28.7" height="28.7" />
          <rect x="83.3" y="485.6" width="28.7" height="28.7" />
          <rect x="83.3" y="514.4" width="28.7" height="28.7" />
          <rect x="83.3" y="543.1" width="28.7" height="28.7" />
          <rect x="83.3" y="571.8" width="28.7" height="28.7" />
          <rect x="83.3" y="600.6" width="28.7" height="28.7" />
          <rect x="83.3" y="629.3" width="28.7" height="28.7" />
          <rect x="83.3" y="658" width="28.7" height="28.7" />
          <rect x="112.1" y="571.8" width="28.7" height="28.7" />
          <rect x="112.1" y="629.3" width="28.7" height="28.7" />
          <rect x="140.8" y="313.2" width="28.7" height="28.7" />
          <rect x="140.8" y="342" width="28.7" height="28.7" />
          <rect x="140.8" y="370.7" width="28.7" height="28.7" />
          <rect x="140.8" y="399.4" width="28.7" height="28.7" />
          <rect x="140.8" y="428.2" width="28.7" height="28.7" />
          <rect x="140.8" y="514.4" width="28.7" height="28.7" />
          <rect x="140.8" y="543.1" width="28.7" height="28.7" />
          <rect x="140.8" y="571.8" width="28.7" height="28.7" />
          <rect x="169.5" y="342" width="28.7" height="28.7" />
          <rect x="169.5" y="370.7" width="28.7" height="28.7" />
          <rect x="169.5" y="399.4" width="28.7" height="28.7" />
          <rect x="169.5" y="456.9" width="28.7" height="28.7" />
          <rect x="169.5" y="485.6" width="28.7" height="28.7" />
          <rect x="169.5" y="514.4" width="28.7" height="28.7" />
          <rect x="169.5" y="543.1" width="28.7" height="28.7" />
          <rect x="169.5" y="600.6" width="28.7" height="28.7" />
          <rect x="169.5" y="629.3" width="28.7" height="28.7" />
          <rect x="198.3" y="313.2" width="28.7" height="28.7" />
          <rect x="198.3" y="514.4" width="28.7" height="28.7" />
          <rect x="198.3" y="571.8" width="28.7" height="28.7" />
          <rect x="198.3" y="600.6" width="28.7" height="28.7" />
          <rect x="198.3" y="658" width="28.7" height="28.7" />
          <rect x="227" y="313.2" width="28.7" height="28.7" />
          <rect x="227" y="342" width="28.7" height="28.7" />
          <rect x="227" y="370.7" width="28.7" height="28.7" />
          <rect x="227" y="456.9" width="28.7" height="28.7" />
          <rect x="227" y="485.6" width="28.7" height="28.7" />
          <rect x="227" y="514.4" width="28.7" height="28.7" />
          <rect x="227" y="543.1" width="28.7" height="28.7" />
          <rect x="227" y="571.8" width="28.7" height="28.7" />
          <rect x="227" y="629.3" width="28.7" height="28.7" />
          <rect x="227" y="658" width="28.7" height="28.7" />
          <rect x="255.7" y="313.2" width="28.7" height="28.7" />
          <rect x="255.7" y="370.7" width="28.7" height="28.7" />
          <rect x="255.7" y="428.2" width="28.7" height="28.7" />
          <rect x="255.7" y="485.6" width="28.7" height="28.7" />
          <rect x="255.7" y="543.1" width="28.7" height="28.7" />
          <rect x="255.7" y="600.6" width="28.7" height="28.7" />
          <rect x="255.7" y="658" width="28.7" height="28.7" />
          <rect x="284.5" y="370.7" width="28.7" height="28.7" />
          <rect x="284.5" y="399.4" width="28.7" height="28.7" />
          <rect x="284.5" y="428.2" width="28.7" height="28.7" />
          <rect x="284.5" y="456.9" width="28.7" height="28.7" />
          <rect x="284.5" y="485.6" width="28.7" height="28.7" />
          <rect x="284.5" y="514.4" width="28.7" height="28.7" />
          <rect x="284.5" y="543.1" width="28.7" height="28.7" />
          <rect x="284.5" y="629.3" width="28.7" height="28.7" />
          <rect x="313.2" y="112.1" width="28.7" height="28.7" />
          <rect x="313.2" y="198.3" width="28.7" height="28.7" />
          <rect x="313.2" y="255.7" width="28.7" height="28.7" />
          <rect x="313.2" y="313.2" width="28.7" height="28.7" />
          <rect x="313.2" y="342" width="28.7" height="28.7" />
          <rect x="313.2" y="456.9" width="28.7" height="28.7" />
          <rect x="313.2" y="485.6" width="28.7" height="28.7" />
          <rect x="313.2" y="543.1" width="28.7" height="28.7" />
          <rect x="313.2" y="629.3" width="28.7" height="28.7" />
          <rect x="313.2" y="658" width="28.7" height="28.7" />
          <rect x="313.2" y="686.8" width="28.7" height="28.7" />
          <rect x="313.2" y="744.3" width="28.7" height="28.7" />
          <rect x="313.2" y="773" width="28.7" height="28.7" />
          <rect x="313.2" y="830.5" width="28.7" height="28.7" />
          <rect x="342" y="83.3" width="28.7" height="28.7" />
          <rect x="342" y="198.3" width="28.7" height="28.7" />
          <rect x="342" y="284.5" width="28.7" height="28.7" />
          <rect x="342" y="342" width="28.7" height="28.7" />
          <rect x="342" y="428.2" width="28.7" height="28.7" />
          <rect x="342" y="456.9" width="28.7" height="28.7" />
          <rect x="342" y="514.4" width="28.7" height="28.7" />
          <rect x="342" y="543.1" width="28.7" height="28.7" />
          <rect x="342" y="600.6" width="28.7" height="28.7" />
          <rect x="342" y="686.8" width="28.7" height="28.7" />
          <rect x="342" y="715.5" width="28.7" height="28.7" />
          <rect x="342" y="744.3" width="28.7" height="28.7" />
          <rect x="342" y="773" width="28.7" height="28.7" />
          <rect x="342" y="801.7" width="28.7" height="28.7" />
          <rect x="342" y="859.2" width="28.7" height="28.7" />
          <rect x="342" y="887.9" width="28.7" height="28.7" />
          <rect x="370.7" y="112.1" width="28.7" height="28.7" />
          <rect x="370.7" y="169.5" width="28.7" height="28.7" />
          <rect x="370.7" y="227" width="28.7" height="28.7" />
          <rect x="370.7" y="255.7" width="28.7" height="28.7" />
          <rect x="370.7" y="313.2" width="28.7" height="28.7" />
          <rect x="370.7" y="342" width="28.7" height="28.7" />
          <rect x="370.7" y="658" width="28.7" height="28.7" />
          <rect x="370.7" y="686.8" width="28.7" height="28.7" />
          <rect x="370.7" y="773" width="28.7" height="28.7" />
          <rect x="370.7" y="801.7" width="28.7" height="28.7" />
          <rect x="370.7" y="887.9" width="28.7" height="28.7" />
          <rect x="399.4" y="112.1" width="28.7" height="28.7" />
          <rect x="399.4" y="169.5" width="28.7" height="28.7" />
          <rect x="399.4" y="198.3" width="28.7" height="28.7" />
          <rect x="399.4" y="227" width="28.7" height="28.7" />
          <rect x="399.4" y="284.5" width="28.7" height="28.7" />
          <rect x="399.4" y="313.2" width="28.7" height="28.7" />
          <rect x="399.4" y="629.3" width="28.7" height="28.7" />
          <rect x="399.4" y="658" width="28.7" height="28.7" />
          <rect x="399.4" y="686.8" width="28.7" height="28.7" />
          <rect x="399.4" y="773" width="28.7" height="28.7" />
          <rect x="399.4" y="859.2" width="28.7" height="28.7" />
          <rect x="399.4" y="887.9" width="28.7" height="28.7" />
          <rect x="428.2" y="83.3" width="28.7" height="28.7" />
          <rect x="428.2" y="140.8" width="28.7" height="28.7" />
          <rect x="428.2" y="198.3" width="28.7" height="28.7" />
          <rect x="428.2" y="255.7" width="28.7" height="28.7" />
          <rect x="428.2" y="744.3" width="28.7" height="28.7" />
          <rect x="428.2" y="801.7" width="28.7" height="28.7" />
          <rect x="428.2" y="887.9" width="28.7" height="28.7" />
          <rect x="456.9" y="112.1" width="28.7" height="28.7" />
          <rect x="456.9" y="198.3" width="28.7" height="28.7" />
          <rect x="456.9" y="227" width="28.7" height="28.7" />
          <rect x="456.9" y="715.5" width="28.7" height="28.7" />
          <rect x="456.9" y="773" width="28.7" height="28.7" />
          <rect x="456.9" y="830.5" width="28.7" height="28.7" />
          <rect x="456.9" y="859.2" width="28.7" height="28.7" />
          <rect x="456.9" y="887.9" width="28.7" height="28.7" />
          <rect x="485.6" y="112.1" width="28.7" height="28.7" />
          <rect x="485.6" y="169.5" width="28.7" height="28.7" />
          <rect x="485.6" y="255.7" width="28.7" height="28.7" />
          <rect x="485.6" y="284.5" width="28.7" height="28.7" />
          <rect x="485.6" y="342" width="28.7" height="28.7" />
          <rect x="485.6" y="658" width="28.7" height="28.7" />
          <rect x="485.6" y="715.5" width="28.7" height="28.7" />
          <rect x="485.6" y="773" width="28.7" height="28.7" />
          <rect x="485.6" y="887.9" width="28.7" height="28.7" />
          <rect x="514.4" y="198.3" width="28.7" height="28.7" />
          <rect x="514.4" y="284.5" width="28.7" height="28.7" />
          <rect x="514.4" y="313.2" width="28.7" height="28.7" />
          <rect x="514.4" y="342" width="28.7" height="28.7" />
          <rect x="514.4" y="744.3" width="28.7" height="28.7" />
          <rect x="514.4" y="801.7" width="28.7" height="28.7" />
          <rect x="514.4" y="859.2" width="28.7" height="28.7" />
          <rect x="514.4" y="887.9" width="28.7" height="28.7" />
          <rect x="543.1" y="83.3" width="28.7" height="28.7" />
          <rect x="543.1" y="112.1" width="28.7" height="28.7" />
          <rect x="543.1" y="140.8" width="28.7" height="28.7" />
          <rect x="543.1" y="169.5" width="28.7" height="28.7" />
          <rect x="543.1" y="198.3" width="28.7" height="28.7" />
          <rect x="543.1" y="227" width="28.7" height="28.7" />
          <rect x="543.1" y="255.7" width="28.7" height="28.7" />
          <rect x="543.1" y="313.2" width="28.7" height="28.7" />
          <rect x="543.1" y="342" width="28.7" height="28.7" />
          <rect x="543.1" y="629.3" width="28.7" height="28.7" />
          <rect x="543.1" y="658" width="28.7" height="28.7" />
          <rect x="543.1" y="686.8" width="28.7" height="28.7" />
          <rect x="543.1" y="887.9" width="28.7" height="28.7" />
          <rect x="571.8" y="83.3" width="28.7" height="28.7" />
          <rect x="571.8" y="112.1" width="28.7" height="28.7" />
          <rect x="571.8" y="169.5" width="28.7" height="28.7" />
          <rect x="571.8" y="227" width="28.7" height="28.7" />
          <rect x="571.8" y="284.5" width="28.7" height="28.7" />
          <rect x="571.8" y="313.2" width="28.7" height="28.7" />
          <rect x="571.8" y="686.8" width="28.7" height="28.7" />
          <rect x="571.8" y="715.5" width="28.7" height="28.7" />
          <rect x="571.8" y="773" width="28.7" height="28.7" />
          <rect x="571.8" y="887.9" width="28.7" height="28.7" />
          <rect x="600.6" y="140.8" width="28.7" height="28.7" />
          <rect x="600.6" y="255.7" width="28.7" height="28.7" />
          <rect x="600.6" y="284.5" width="28.7" height="28.7" />
          <rect x="600.6" y="313.2" width="28.7" height="28.7" />
          <rect x="600.6" y="342" width="28.7" height="28.7" />
          <rect x="600.6" y="658" width="28.7" height="28.7" />
          <rect x="600.6" y="744.3" width="28.7" height="28.7" />
          <rect x="600.6" y="830.5" width="28.7" height="28.7" />
          <rect x="600.6" y="887.9" width="28.7" height="28.7" />
          <rect x="629.3" y="169.5" width="28.7" height="28.7" />
          <rect x="629.3" y="227" width="28.7" height="28.7" />
          <rect x="629.3" y="313.2" width="28.7" height="28.7" />
          <rect x="629.3" y="370.7" width="28.7" height="28.7" />
          <rect x="629.3" y="399.4" width="28.7" height="28.7" />
          <rect x="629.3" y="456.9" width="28.7" height="28.7" />
          <rect x="629.3" y="485.6" width="28.7" height="28.7" />
          <rect x="629.3" y="571.8" width="28.7" height="28.7" />
          <rect x="629.3" y="600.6" width="28.7" height="28.7" />
          <rect x="629.3" y="801.7" width="28.7" height="28.7" />
          <rect x="658" y="83.3" width="28.7" height="28.7" />
          <rect x="658" y="112.1" width="28.7" height="28.7" />
          <rect x="658" y="140.8" width="28.7" height="28.7" />
          <rect x="658" y="169.5" width="28.7" height="28.7" />
          <rect x="658" y="255.7" width="28.7" height="28.7" />
          <rect x="658" y="313.2" width="28.7" height="28.7" />
          <rect x="658" y="370.7" width="28.7" height="28.7" />
          <rect x="658" y="399.4" width="28.7" height="28.7" />
          <rect x="658" y="514.4" width="28.7" height="28.7" />
          <rect x="658" y="543.1" width="28.7" height="28.7" />
          <rect x="658" y="571.8" width="28.7" height="28.7" />
          <rect x="658" y="629.3" width="28.7" height="28.7" />
          <rect x="658" y="658" width="28.7" height="28.7" />
          <rect x="658" y="686.8" width="28.7" height="28.7" />
          <rect x="658" y="715.5" width="28.7" height="28.7" />
          <rect x="658" y="744.3" width="28.7" height="28.7" />
          <rect x="658" y="773" width="28.7" height="28.7" />
          <rect x="658" y="801.7" width="28.7" height="28.7" />
          <rect x="658" y="887.9" width="28.7" height="28.7" />
          <rect x="686.8" y="313.2" width="28.7" height="28.7" />
          <rect x="686.8" y="370.7" width="28.7" height="28.7" />
          <rect x="686.8" y="399.4" width="28.7" height="28.7" />
          <rect x="686.8" y="456.9" width="28.7" height="28.7" />
          <rect x="686.8" y="485.6" width="28.7" height="28.7" />
          <rect x="686.8" y="514.4" width="28.7" height="28.7" />
          <rect x="686.8" y="543.1" width="28.7" height="28.7" />
          <rect x="686.8" y="571.8" width="28.7" height="28.7" />
          <rect x="686.8" y="600.6" width="28.7" height="28.7" />
          <rect x="686.8" y="658" width="28.7" height="28.7" />
          <rect x="686.8" y="773" width="28.7" height="28.7" />
          <rect x="686.8" y="830.5" width="28.7" height="28.7" />
          <rect x="686.8" y="887.9" width="28.7" height="28.7" />
          <rect x="715.5" y="370.7" width="28.7" height="28.7" />
          <rect x="715.5" y="456.9" width="28.7" height="28.7" />
          <rect x="715.5" y="514.4" width="28.7" height="28.7" />
          <rect x="715.5" y="600.6" width="28.7" height="28.7" />
          <rect x="715.5" y="629.3" width="28.7" height="28.7" />
          <rect x="715.5" y="658" width="28.7" height="28.7" />
          <rect x="715.5" y="715.5" width="28.7" height="28.7" />
          <rect x="715.5" y="773" width="28.7" height="28.7" />
          <rect x="715.5" y="887.9" width="28.7" height="28.7" />
          <rect x="744.3" y="370.7" width="28.7" height="28.7" />
          <rect x="744.3" y="456.9" width="28.7" height="28.7" />
          <rect x="744.3" y="514.4" width="28.7" height="28.7" />
          <rect x="744.3" y="543.1" width="28.7" height="28.7" />
          <rect x="744.3" y="629.3" width="28.7" height="28.7" />
          <rect x="744.3" y="658" width="28.7" height="28.7" />
          <rect x="744.3" y="773" width="28.7" height="28.7" />
          <rect x="744.3" y="801.7" width="28.7" height="28.7" />
          <rect x="744.3" y="859.2" width="28.7" height="28.7" />
          <rect x="744.3" y="887.9" width="28.7" height="28.7" />
          <rect x="773" y="313.2" width="28.7" height="28.7" />
          <rect x="773" y="370.7" width="28.7" height="28.7" />
          <rect x="773" y="399.4" width="28.7" height="28.7" />
          <rect x="773" y="428.2" width="28.7" height="28.7" />
          <rect x="773" y="485.6" width="28.7" height="28.7" />
          <rect x="773" y="514.4" width="28.7" height="28.7" />
          <rect x="773" y="543.1" width="28.7" height="28.7" />
          <rect x="773" y="629.3" width="28.7" height="28.7" />
          <rect x="773" y="658" width="28.7" height="28.7" />
          <rect x="773" y="686.8" width="28.7" height="28.7" />
          <rect x="773" y="715.5" width="28.7" height="28.7" />
          <rect x="773" y="744.3" width="28.7" height="28.7" />
          <rect x="773" y="773" width="28.7" height="28.7" />
          <rect x="801.7" y="370.7" width="28.7" height="28.7" />
          <rect x="801.7" y="456.9" width="28.7" height="28.7" />
          <rect x="801.7" y="485.6" width="28.7" height="28.7" />
          <rect x="801.7" y="600.6" width="28.7" height="28.7" />
          <rect x="801.7" y="744.3" width="28.7" height="28.7" />
          <rect x="801.7" y="801.7" width="28.7" height="28.7" />
          <rect x="801.7" y="859.2" width="28.7" height="28.7" />
          <rect x="830.5" y="370.7" width="28.7" height="28.7" />
          <rect x="830.5" y="399.4" width="28.7" height="28.7" />
          <rect x="830.5" y="428.2" width="28.7" height="28.7" />
          <rect x="830.5" y="456.9" width="28.7" height="28.7" />
          <rect x="830.5" y="514.4" width="28.7" height="28.7" />
          <rect x="830.5" y="600.6" width="28.7" height="28.7" />
          <rect x="830.5" y="629.3" width="28.7" height="28.7" />
          <rect x="830.5" y="658" width="28.7" height="28.7" />
          <rect x="830.5" y="686.8" width="28.7" height="28.7" />
          <rect x="830.5" y="801.7" width="28.7" height="28.7" />
          <rect x="830.5" y="859.2" width="28.7" height="28.7" />
          <rect x="830.5" y="887.9" width="28.7" height="28.7" />
          <rect x="859.2" y="313.2" width="28.7" height="28.7" />
          <rect x="859.2" y="342" width="28.7" height="28.7" />
          <rect x="859.2" y="399.4" width="28.7" height="28.7" />
          <rect x="859.2" y="514.4" width="28.7" height="28.7" />
          <rect x="859.2" y="543.1" width="28.7" height="28.7" />
          <rect x="859.2" y="571.8" width="28.7" height="28.7" />
          <rect x="859.2" y="600.6" width="28.7" height="28.7" />
          <rect x="859.2" y="629.3" width="28.7" height="28.7" />
          <rect x="859.2" y="658" width="28.7" height="28.7" />
          <rect x="859.2" y="686.8" width="28.7" height="28.7" />
          <rect x="859.2" y="744.3" width="28.7" height="28.7" />
          <rect x="859.2" y="801.7" width="28.7" height="28.7" />
          <rect x="859.2" y="859.2" width="28.7" height="28.7" />
          <rect x="859.2" y="887.9" width="28.7" height="28.7" />
          <rect x="887.9" y="342" width="28.7" height="28.7" />
          <rect x="887.9" y="399.4" width="28.7" height="28.7" />
          <rect x="887.9" y="485.6" width="28.7" height="28.7" />
          <rect x="887.9" y="571.8" width="28.7" height="28.7" />
          <rect x="887.9" y="658" width="28.7" height="28.7" />
          <rect x="887.9" y="715.5" width="28.7" height="28.7" />
          <rect x="887.9" y="773" width="28.7" height="28.7" />
          <rect x="887.9" y="859.2" width="28.7" height="28.7" />
          <path d="M83.3,83.3v201.1h201.1V83.3H83.3ZM112.1,112.1h143.7v143.7H112.1V112.1Z" />
          <rect x="140.8" y="140.8" width="86.2" height="86.2" />
          <path d="M916.7,83.3h-201.1v201.1h201.1V83.3ZM887.9,112.1v143.7h-143.7V112.1h143.7Z" />
          <rect x="773" y="140.8" width="86.2" height="86.2" />
          <path d="M83.3,916.7h201.1v-201.1H83.3v201.1ZM112.1,887.9v-143.7h143.7v143.7H112.1Z" />
          <rect x="140.8" y="773" width="86.2" height="86.2" />
          <path d="M573.6,493.2l-31.5-54.5c-2.4-4.2-6.9-6.8-11.7-6.8h-62.9c-4.8,0-9.3,2.6-11.7,6.8l-31.5,54.5c-2.4,4.2-2.4,9.3,0,13.5l31.5,54.5c2.4,4.2,6.9,6.8,11.7,6.8h62.9c4.8,0,9.3-2.6,11.7-6.8l31.5-54.5c2.4-4.2,2.4-9.3,0-13.5ZM470.8,467.8c0-5,4-9,9-9h37.3c5,0,9,4,9,9v1.5c0,5-4,9-9,9h-37.3c-5,0-9-4-9-9v-1.5ZM516.6,532.1c0,5-4,9-9,9h-18.1c-5,0-9-4-9-9v-1.5c0-5,4-9,9-9h18.1c5,0,9,4,9,9v1.5ZM545.4,500.8c0,5-4,9-9,9h-75.9c-5,0-9-4-9-9v-1.5c0-5,4-9,9-9h75.9c5,0,9,4,9,9v1.5Z" />
        </svg>
      </div>
    </div>
  );
};
